import { translate, useLocale } from "../../localization";
import { useAnalytics } from "../../context/AnalyticsContext";
import "./DashboardGlobal.scss";
import { isNewAnalyticsEnabled } from "../../services/AnalyticsReadAPI";

const Statistics = () => {
  useLocale();

  const { statistics } = useAnalytics();


  const formatSeconds = seconds => `${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, '0')}`;

  return (
    <div className="stats-row">
      <div className="stat-card">
        <div className="stat-label">{translate("TIME SPENT")}</div>
        <div className="stat-value">{isNewAnalyticsEnabled ? (statistics.averageTime == null ? "—" : formatSeconds(Math.round(statistics.averageTime))) : formatSeconds(statistics.averageTime)}</div>
        <div className="stat-sub">{translate("Average")}</div>
      </div>
  
      <div className="stat-card">
        <div className="stat-label">{translate("SESSIONS")}</div>
        <div className="stat-value">{Math.ceil(statistics.totalSessionCount)}</div>
        <div className="stat-sub">{translate("Total")}</div>
      </div>
  
      <div className="stat-card">
        <div className="stat-label">{translate("SCORE")}</div>
        <div className="stat-value">{isNewAnalyticsEnabled && statistics.averageScore == null ? "—" : `${Math.round(statistics.averageScore)}%`}</div>
        <div className="stat-sub">{translate("Average")}</div>
      </div>
    </div>
  );
}

export default Statistics;
